import React from 'react';
import Button from '@jbhi-fi/lanyard-ui/components/Button';

import { styles } from './Reviews.css';
import { StarActual } from './icons/starActual';
import { StarPossible } from './icons/starPossible';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type ReviewsProps = {
  numberOfReviews: number;
  rating: string | number;
  onClick?: (event: React.MouseEvent) => void;
  id?: string;
  variant: 'pdp' | 'productTile';
  className?: string;
  testId?: string;
};

export const Reviews = ({ numberOfReviews, rating, onClick, id, variant, className, testId }: ReviewsProps) => {
  const ratingNum = Number(rating) || 0;
  const starStyle = styles.starIcon({ usage: variant });

  return (
    <div className={classNames([styles.starsContainer, className])} id={id} data-testid={testId}>
      <Button type="link" onClick={e => onClick && onClick(e)} classes={styles.button}>
        <div className={styles.stars}>
          <div className={styles.starsFull} style={{ width: `${ratingNum * 20}%` }}>
            {[...Array(5)].map((_, i) => (
              <StarActual className={starStyle} key={i} />
            ))}
          </div>
          {[...Array(5)].map((_, i) => (
            <StarPossible className={starStyle} key={i} />
          ))}
        </div>
        <span className={styles.reviewText({ usage: variant })}>
          <div className={styles.reviewRating}>{ratingNum.toFixed(1)}</div>
          <div className={styles.reviewCount}>({numberOfReviews})</div>
        </span>
      </Button>
    </div>
  );
};
